import { render } from "./PhysiciansList.vue?vue&type=template&id=4a801762&scoped=true"
import script from "./PhysiciansList.vue?vue&type=script&lang=js"
export * from "./PhysiciansList.vue?vue&type=script&lang=js"

import "./PhysiciansList.vue?vue&type=style&index=0&id=4a801762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a801762"]])

export default __exports__